/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V3EngagementRateTarget {
    'engagementRateType'?: string;
    'engagementRatePct'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "engagementRateType",
            "baseName": "engagement_rate_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "engagementRatePct",
            "baseName": "engagement_rate_pct",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return V3EngagementRateTarget.attributeTypeMap;
    }

    public constructor() {
    }
}

